var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('SecondaryButton',_vm._g(_vm._b({attrs:{"btnClass":"mr-2 rounded","icon":"mdi-eye","iconClass":"","x-small":""},on:{"click":_vm.viewDetails}},'SecondaryButton',attrs,false),on))]}}])},[_c('span',[_vm._v("View")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }